export default __webpack_public_path__ + "static/media/before-after-hearts.62006d60.png";